var langMixin = {

  computed: {
    // lang () {
    //   if (!this.lesson) {
    //     return ''
    //   }

    //   let key = ['language', 'Language']
    //   let property = ''

    //   for (let k in this.lesson) {
    //     if (this.lesson.hasOwnProperty(k) && key.indexOf(k) > -1) {
    //       property = k
    //       break
    //     }
    //   }

    //   return property === '' ? property : this.lesson[property]
    // }
  },

  methods: {
    toJap (sent, hidePinyin = false) {
      // if (this.lang !== 'Ja') {
      //   return sent
      // }

      this.forceToJap(sent, hidePinyin)
    },

    forceToJap (sent, hidePinyin = false) {
      let split = sent.split(/{(.+?)}/)
      let newSent = ''
      for (let i in split) {
        if (split[i].indexOf('=') > -1) {
          if (!hidePinyin) {
            newSent += '<ruby>' + split[i].split(/=/)[0] + '<rt>' + split[i].split(/=/)[1] + '</rt></ruby>'
          } else {
            newSent += split[i].split(/=/)[0]
          }
        } else {
          newSent += split[i]
        }
      }
      return newSent
    },

    rubyParsing (data) {
      if (typeof data === 'string') {
        return this.forceToJap(data)
      } else if (Array.isArray(data)) {
        for (let i = data.length - 1; i >= 0; i--) {
          data[i] = this.rubyParsing(data[i])
        }
      } else if (data && typeof data === 'object') {
        for (let k in data) {
          data[k] = this.rubyParsing(data[k])
        }
      }

      return data
    },

    jsonDataParsingRuby (data) {
      return this.rubyParsing(data)
    }
  }
}

export default langMixin



// WEBPACK FOOTER //
// ./src/components/langMixin.js